import type { Route, RouteFocus, RouteName } from "../types";

export type RouteHandler = (route: Route) => void | Promise<void>;

const ROUTES: RouteName[] = ["read", "library", "statistics", "data", "settings", "diagnosis"];

function parseHash(): Route {
  const raw = location.hash.replace(/^#\/?/, "");
  const [path, query = ""] = raw.split("?");
  const name = (path || "read") as RouteName;
  const params = new URLSearchParams(query);
  const focusRaw = params.get("focus");
  const focus: RouteFocus =
    focusRaw === "import" || focusRaw === "export" ? focusRaw : null;
  const readingId = params.get("id") || params.get("readingId") || null;

  return {
    name: ROUTES.includes(name) ? name : "read",
    focus,
    readingId,
  };
}

export function startRouter(onRoute: RouteHandler): void {
  const run = () => {
    void onRoute(parseHash());
  };
  window.addEventListener("hashchange", run);
  run();
}

export function navigate(
  name: RouteName,
  focus: RouteFocus = null,
  readingId: string | null = null,
): void {
  location.hash = routeHref(name, focus, readingId);
}

export function routeHref(
  name: RouteName,
  focus: RouteFocus = null,
  readingId: string | null = null,
): string {
  const params = new URLSearchParams();
  if (focus) {
    params.set("focus", focus);
  }
  if (readingId) {
    params.set("id", readingId);
  }
  const qs = params.toString();
  return `#/${name}${qs ? `?${qs}` : ""}`;
}

export function isActiveRoute(current: Route, name: RouteName): boolean {
  return current.name === name;
}
